/**
 * FAX転送先ドメインなど、アプリケーション全体で使用する定数
 */
export const FAX_DOMAIN = "ai-ibs.com";
